@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
}

<div class="draft-detail-content">
  <div class="draft-detail-heading">
    <span class="label-medium-emphasized">
      Brogliaccio N° {{ dettaglio.numeroBrogliaccio }}
    </span>
    <span class="body-medium draft-status-badge" [ngClass]="statusBadgeClass(dettaglio.situazione)">
      {{ dettaglio.situazione }}
    </span>
  </div>

  @if (dettaglio.versamentiContanti.length > 0) {
    <div class="draft-detail-group">
      <span class="label-medium-emphasized">Versamenti in contante confluiti</span>

      @for (versamento of dettaglio.versamentiContanti; track versamento.idIncasso) {
        <div class="draft-detail-card">
          <div class="draft-detail-card-text">
            <div class="draft-detail-first-row">
              <div class="draft-detail-pair">
                <span class="body-small">Incasso:</span>
                <span class="body-small-emphasized">{{ versamento.idIncasso }}</span>
              </div>
              <div class="draft-detail-pair">
                <span class="body-small">Data:</span>
                <span class="body-small-emphasized">
                  {{ versamento.dataIncasso | date:'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">Cliente:</span>
              <span class="body-small-emphasized">{{ versamento.cliente }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">Monete:</span>
              <span class="body-small-emphasized">
                {{ versamento.importoMonete | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">Banconote:</span>
              <span class="body-small-emphasized">
                {{ versamento.importoBanconote | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
            <div class="draft-detail-row">
              <span class="body-large-emphasized">Totale:</span>
              <span class="body-large-emphasized">
                {{ versamento.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (dettaglio.assegni.length > 0) {
    <div class="draft-detail-group">
      <span class="label-medium-emphasized">Assegni confluiti</span>

      @for (assegno of dettaglio.assegni; track $index) {
        <div class="draft-detail-card">
          <div class="draft-detail-card-text">
            <div class="draft-detail-first-row">
              <div class="draft-detail-pair">
                <span class="body-small">Incasso:</span>
                <span class="body-small-emphasized">{{ assegno.idIncasso }}</span>
              </div>
              <div class="draft-detail-pair">
                <span class="body-small">Data:</span>
                <span class="body-small-emphasized">
                  {{ assegno.dataIncasso | date:'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">Cliente:</span>
              <span class="body-small-emphasized">{{ assegno.cliente }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">ABI:</span>
              <span class="body-small-emphasized">{{ assegno.abi }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">CAB:</span>
              <span class="body-small-emphasized">{{ assegno.cab }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">Banca:</span>
              <span class="body-small-emphasized">{{ assegno.banca }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">N. Assegno:</span>
              <span class="body-small-emphasized">{{ assegno.numeroAssegno }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-large-emphasized">Importo:</span>
              <span class="body-large-emphasized">
                {{ assegno.importo | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="draft-detail-group">
    <span class="label-medium-emphasized">Partite associate</span>

    @for (partita of dettaglio.partiteAssociate; track partita.numeroDocumento) {
      <div class="draft-detail-card">
        <div class="draft-detail-card-text">
          <div class="draft-detail-row">
            <span class="body-small">Num. Doc.</span>
            <span class="body-small-emphasized">{{ partita.numeroDocumento }}</span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">Data documento:</span>
            <span class="body-small-emphasized">
              {{ partita.dataDocumento | date:'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">Scadenza:</span>
            <span class="body-small-emphasized">
              {{ partita.dataScadenza | date:'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">Totale fattura:</span>
            <span class="body-small-emphasized">
              {{ partita.totaleFattura | currency:'EUR':'symbol':'1.2-2' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">Assegnato:</span>
            <span class="body-small-emphasized">
              {{ partita.importoAssegnato | currency:'EUR':'symbol':'1.2-2' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">Residuo:</span>
            <span class="body-small-emphasized">
              {{ partita.importoResiduo | currency:'EUR':'symbol':'1.2-2' }}
            </span>
          </div>
          <div class="draft-detail-row">
            <span class="body-small">Da incasso:</span>
            <span class="body-small-emphasized">{{ partita.idIncasso }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<div class="draft-detail-summary">
  <span class="body-large-emphasized">Riepilogo BROGLIACCIO</span>

  <div class="draft-summary-row">
    <span class="body-small">Totale Contanti</span>
    <span class="body-small-emphasized">
      {{ dettaglio.riepilogo.totaleContanti | currency:'EUR':'symbol':'1.2-2' }}
    </span>
  </div>

  <div class="draft-summary-row">
    <span class="body-small">Totale Assegni</span>
    <span class="body-small-emphasized">
      {{ dettaglio.riepilogo.totaleAssegni | currency:'EUR':'symbol':'1.2-2' }}
    </span>
  </div>

  <div class="draft-detail-divider"></div>

  <div class="draft-summary-row">
    <span class="headline-small-emphasized">Totale Generale</span>
    <span class="headline-small-emphasized">
      {{ dettaglio.riepilogo.totaleGenerale | currency:'EUR':'symbol':'1.2-2' }}
    </span>
  </div>
  @if (dettaglio.acconti.length > 0) {
    <div class="draft-detail-group">
      <span class="label-medium-emphasized">Acconti</span>

      @for (acconto of dettaglio.acconti; track acconto.codiceCliente) {
        <div class="draft-detail-card">
          <div class="draft-detail-card-text">
            <div class="draft-detail-first-row">
              <div class="draft-detail-pair">
                <span class="body-small">Incasso:</span>
                <span class="body-small-emphasized">{{ acconto.idIncasso }}</span>
              </div>
              <div class="draft-detail-pair">
                <span class="body-small">Cod. cliente:</span>
                <span class="body-small-emphasized">{{ acconto.codiceCliente }}</span>
              </div>
            </div>
            <div class="draft-detail-row">
              <span class="body-small">Cliente:</span>
              <span class="body-small-emphasized">{{ acconto.cliente }}</span>
            </div>
            <div class="draft-detail-row">
              <span class="body-large-emphasized">Importo:</span>
              <span class="body-large-emphasized">
                {{ acconto.importo | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

@if (puoConfermare) {
  <button
    matButton="filled"
    type="button"
    class="draft-detail-confirm-button"
    *uiCan="CAPS.brogliaccioConferma"
    [disabled]="isSaving"
    (click)="conferma()"
  >
    Conferma
  </button>
}

@if (puoEliminare) {
  <button
    matButton="outlined"
    type="button"
    class="draft-detail-delete-button draft-detail-delete-mobile-button"
    *uiCan="CAPS.brogliaccioElimina"
    [disabled]="isSaving"
    (click)="elimina()"
  >
    Elimina
  </button>
}

<div class="draft-detail-desktop">
  @if (dettaglio.versamentiContanti.length > 0) {
    <section class="draft-detail-desktop-card">
      <span class="label-medium-emphasized">Versamenti in contante confluiti</span>
      <ui-table-view
        [columnsInfo]="versamentiContantiColumns"
        [data]="versamentiContantiTable"
      />
    </section>
  }

  @if (dettaglio.assegni.length > 0) {
    <section class="draft-detail-desktop-card">
      <span class="label-medium-emphasized">Assegni confluiti</span>
      <ui-table-view
        [columnsInfo]="assegniColumns"
        [data]="assegniTable"
      />
    </section>
  }

  <section class="draft-detail-desktop-card">
    <span class="label-medium-emphasized">Partite associate</span>
    <ui-table-view
      [columnsInfo]="partiteAssociateColumns"
      [data]="partiteAssociateTable"
    />
  </section>

  @if (dettaglio.acconti.length > 0) {
    <section class="draft-detail-desktop-card">
      <span class="label-medium-emphasized">Acconti</span>
      <ui-table-view
        [columnsInfo]="accontiColumns"
        [data]="accontiTable"
      />
    </section>
  }

  <section class="draft-detail-desktop-card draft-detail-desktop-summary">
    <div class="draft-detail-desktop-heading">
      <span class="label-medium-emphasized">
        Riepilogo brogliaccio N° {{ dettaglio.numeroBrogliaccio }}
      </span>
      <span class="body-medium draft-status-badge" [ngClass]="statusBadgeClass(dettaglio.situazione)">
        {{ dettaglio.situazione }}
      </span>
    </div>

    <div class="draft-detail-desktop-fields">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Totale contanti</mat-label>
        <input
          matInput
          readonly
          [value]="dettaglio.riepilogo.totaleContanti | currency:'EUR':'symbol':'1.2-2'"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Totale assegni</mat-label>
        <input
          matInput
          readonly
          [value]="dettaglio.riepilogo.totaleAssegni | currency:'EUR':'symbol':'1.2-2'"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Totale generale</mat-label>
        <input
          matInput
          readonly
          [value]="dettaglio.riepilogo.totaleGenerale | currency:'EUR':'symbol':'1.2-2'"
        />
      </mat-form-field>
    </div>

    <div class="draft-detail-desktop-actions">
      @if (puoConfermare) {
        <button
          matButton="filled"
          type="button"
          class="draft-detail-action-wide"
          *uiCan="CAPS.brogliaccioConferma"
          [disabled]="isSaving"
          (click)="conferma()"
        >
          Conferma
        </button>
      }
      <button matButton="outlined" type="button" class="draft-detail-action-wide" disabled>
        Stampa
      </button>
      <button matButton="outlined" type="button" (click)="tornaIndietro()">
        Esci
      </button>
      @if (puoEliminare) {
        <button
          matButton="outlined"
          type="button"
          class="draft-detail-delete-button"
          *uiCan="CAPS.brogliaccioElimina"
          [disabled]="isSaving"
          (click)="elimina()"
        >
          Elimina
        </button>
      }
    </div>
  </section>
</div>
